/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import MiddleColumnSkeletonTop from './MiddleColumnSkeletonTop';
import MiddleColumnSkeletonBottom from './MiddleColumnSkeletonBottom';

export const MiddleColumnSkeleton = () => {
  return (
    <div data-testid="product-availability-info-center-skeleton">
      <MiddleColumnSkeletonTop />
      <MiddleColumnSkeletonBottom />
    </div>
  );
};
